import React, { useContext, useRef, useState, useEffect } from "react";
import sha256 from "crypto-js/sha256";
import { CgDuplicate } from "react-icons/cg";
import { AuthContext } from "../context/AuthContext";
import noProfile from "../images/pictures/no-profile.png";
import brokenImage from "../images/pictures/broken-image.png";

import {
  db,
  storage,
  serverTime,
  eventChanged,
  eventPaused,
  eventRunning,
} from "../Utils/firebase";

function EditPhoto() {
  const { userData, userAuth, setUserData } = useContext(AuthContext);
  const [alert, setAlert] = useState(false);
  const [disable, setDisable] = useState(true);
  const [btnText, setBtnText] = useState("Update");
  const [cancel, setCancel] = useState(false);
  const [error, setError] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mount, setMount] = useState(true);
  const [photoTemp, setPhotoTemp] = useState(() => {
    if (userData.photo_url) {
      if (userData.photo_url !== "") {
        return userData.photo_url;
      } else {
        return noProfile;
      }
    } else {
      return noProfile;
    }
  });

  const photoRef = useRef();

  /*  INITIALIZING */

  const handleChange = (e) => {
    if (window.FileReader && window.Blob) {
      // All the File APIs are supported.
      if (e.target.files && e.target.files[0]) {
        // const fileName = e.target.files[0].name;
        const fileSize = e.target.files[0].size;
        const fileType = e.target.files[0].type;
        setError(null);
        if (fileSize < 999500) {
          if (fileType === "image/png" || fileType === "image/jpeg") {
            const fileReader = new FileReader();
            const file = e.target.files[0];
            fileReader.onloadend = function (e) {
              let arr = new Uint8Array(e.target.result).subarray(0, 4);
              let header = "";
              for (let i = 0; i < arr.length; i++) {
                header += arr[i].toString(16);
              }
              // Check the file signature against known types
              const setType = (header) => {
                switch (header) {
                  case "89504e47":
                    return "image/png";
                  case "47494638":
                    return "image/gif";
                  case "ffd8ffe0":
                  case "ffd8ffe1":
                  case "ffd8ffe2":
                  case "ffd8ffe3":
                  case "ffd8ffe8":
                    return "image/jpeg";
                  default:
                    return "unknown"; // Or you can use the blob.type as fallback
                }
              };
              const typeAllowed = setType(header);

              if (typeAllowed === "image/jpeg" || typeAllowed === "image/png") {
                // &&
                // ALL CLEAR
                setBtnText("Update");
                setDisable(false);
                setCancel(true);
                setFile(file);
                setPhotoTemp(URL.createObjectURL(file));
              } else {
                setError("Only Images are Allowed!");
                if (userData.photo_url) {
                  if (userData.photo_url !== "") {
                    setPhotoTemp(userData.photo_url);
                  } else {
                    setPhotoTemp(noProfile);
                  }
                } else {
                  setPhotoTemp(noProfile);
                }
                setFile(null);
                setBtnText("Update");
                photoRef.current.value = "";
              }
            };
            fileReader.readAsArrayBuffer(e.target.files[0]);
          } else {
            setError("Only Images are Allowed!");
            if (userData.photo_url) {
              if (userData.photo_url !== "") {
                setPhotoTemp(userData.photo_url);
              } else {
                setPhotoTemp(noProfile);
              }
            } else {
              setPhotoTemp(noProfile);
            }
            setFile(null);
            setBtnText("Update");
            photoRef.current.value = "";
          }
        } else {
          setError("Maximum Size 1 MB");
          if (userData.photo_url) {
            if (userData.photo_url !== "") {
              setPhotoTemp(userData.photo_url);
            } else {
              setPhotoTemp(noProfile);
            }
          } else {
            setPhotoTemp(noProfile);
          }
          setFile(null);
          setBtnText("Update");
          photoRef.current.value = "";
        }
      }
    } else {
      // File and Blob are not supported
      setBtnText("Update");
      setError("File and Blob are not supported!");
      setFile(null);
    }
  };

  const handleCancel = () => {
    setError(null);
    setDisable(true);
    setCancel(false);
    setFile(null);
    if (userData.photo_url) {
      if (userData.photo_url !== "") {
        setPhotoTemp(userData.photo_url);
      } else {
        setPhotoTemp(noProfile);
      }
    } else {
      setPhotoTemp(noProfile);
    }
    photoRef.current.value = "";
  };

  const openAlert = (id) => {
    setAlert(true);
    document.body.style.overflow = "hidden";
  };
  const closeAlert = () => {
    setAlert(false);
    document.body.style.removeProperty("overflow");
  };

  const removeButton = () => {
    if (userData.photo_url) {
      if (userData.photo_url !== "") {
        return (
          <p className="text textBold" onClick={openAlert}>
            Remove
          </p>
        );
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setDisable(true);
    setLoading(true);
    const photoHash = sha256(userAuth.uid);

    const storageRef = storage.ref();
    const spaceRef = storageRef.child(`photo/${photoHash}/profile.jpg`);
    const metadata = {
      contentType: "image/jpeg",
    };
    // Upload file and metadata to the object 'images/mountains.jpg'
    var uploadTask = spaceRef.put(file, metadata);
    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(
      eventChanged, // or 'state_changed'
      function (snapshot) {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        let progress = Math.floor(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );

        if (mount) {
          setBtnText("Upload is running");
        }

        switch (snapshot.state) {
          case eventPaused: // or 'paused'
            if (mount) {
              setBtnText("Upload is paused");
            }
            break;
          case eventRunning: // or 'running'
            if (mount) {
              setBtnText("Uploading - " + progress + "%");
            }
            break;
          default:
        }
      },
      function (error) {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors

        switch (error.code) {
          case "storage/unauthorized":
            // User doesn't have permission to access the object
            if (mount) {
              setError("Doesn't have permission");
              setLoading(false);
              setBtnText("Update");
              setDisable(true);
              setCancel(false);
            }
            break;

          case "storage/canceled":
            // User canceled the upload
            if (mount) {
              setError("Canceled the upload");
              setLoading(false);
              setBtnText("Update");
              setDisable(true);
              setCancel(false);
            }
            break;
          case "storage/unknown":
            // Unknown error occurred, inspect error.serverResponse
            if (mount) {
              setError("Server Error!");
              setLoading(false);
              setBtnText("Update");
              setDisable(true);
              setCancel(false);
            }
            break;
          default:
        }
      },
      function () {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          // console.log("File available at", downloadURL);
          setBtnText("Getting files ready ...");
          db.collection("user")
            .doc(userAuth.uid)
            .update({
              photo_url: downloadURL,
              updateAt: serverTime,
            })
            .then(() => {
              db.collection("user")
                .doc(userAuth.uid)
                .get()
                .then((doc) => {
                  setUserData(doc.data());
                  if (mount) {
                    setCancel(false);
                    setLoading(false);
                    setBtnText("Uploaded");
                    setDisable(true);
                  }
                })
                .catch((error) => {
                  if (mount) {
                    setError(error.code);
                    setCancel(false);
                    setLoading(false);
                    setBtnText("Update");
                    setDisable(true);
                  }
                });
            })
            .catch((error) => {
              if (mount) {
                setCancel(false);
                setError(error.code);
                setLoading(false);
                setBtnText("Update");
                setDisable(true);
              }
            });
        });
      }
    );
  };

  const removePhoto = () => {
    const photoHash = sha256(userAuth.uid);
    const storageRef = storage.ref();
    const spaceRef = storageRef.child(`photo/${photoHash}/profile.jpg`);

    setLoading(true);
    setBtnText("Removing ...");
    closeAlert();
    // Delete the file
    spaceRef
      .delete()
      .then(function () {
        // File deleted successfully
        db.collection("user")
          .doc(userAuth.uid)
          .update({
            photo_url: "",
            updateAt: serverTime,
          })
          .then(() => {
            db.collection("user")
              .doc(userAuth.uid)
              .get()
              .then((doc) => {
                setUserData(doc.data());
                if (mount) {
                  setPhotoTemp(noProfile);
                  setLoading(false);
                  setBtnText("Update");
                }
              })
              .catch((error) => {
                if (mount) {
                  setError(error.code);
                  setLoading(false);
                  setBtnText("Update");
                }
              });
          })
          .catch((error) => {
            if (mount) {
              setError(error.code);
              setLoading(false);
              setBtnText("Update");
            }
          });
      })
      .catch(function (error) {
        // Uh-oh, an error occurred!
        if (mount) {
          setError(error.code);
          setLoading(false);
          setBtnText("Update");
        }
      });
  };

  const handleError = (e) => {
    e.target.src = brokenImage;
    e.target.title = "Broken Image";
  };

  useEffect(() => {
    return () => {
      setMount(false);
    };
  }, []);

  return (
    <div
      id="edit-photo"
      className="edit-photo divContent darktextColor darkdivColor"
    >
      {alert && (
        <div className="alert">
          <div className="alert-box">
            <h5>Are you sure ?</h5>
            <p>This action cannot be undone!</p>
            <div className="option-wrap">
              <button onClick={removePhoto}>Yes</button>
              <button onClick={closeAlert}>Cancel</button>
            </div>
          </div>
        </div>
      )}
      <div className="head-tab">
        <h5 className="textTitle textMedium">Photo</h5>
        {loading ? null : (
          <>
            {cancel ? (
              <p className="text textBold" onClick={handleCancel}>
                Cancel
              </p>
            ) : (
              removeButton()
            )}
          </>
        )}
      </div>
      <form
        className="photo-form"
        encType="multipart/form-data"
        onSubmit={handleSubmit}
      >
        <div className="photo-wrapper">
          <input
            type="file"
            id="ifile"
            name="ifile"
            className="input-file"
            accept="image/x-png,image/jpeg"
            onChange={handleChange}
            ref={photoRef}
            disabled={loading}
          />
          <div className="photo-thumb">
            <img
              src={photoTemp}
              alt="Profile"
              title="Profile"
              onError={handleError}
            />
          </div>
          <label htmlFor="ifile">
            {loading ? null : (
              <span>
                <CgDuplicate size="1.2em" />
              </span>
            )}
          </label>
        </div>

        <button
          className={
            disable
              ? "btn-in darktextColor textTitle disable"
              : "btn-in darktextColor textTitle "
          }
          disabled={disable}
          type="submit"
        >
          {btnText}
        </button>
      </form>

      {error ? <p className="error-photo">{error}</p> : null}
    </div>
  );
}

export default EditPhoto;
